module.exports = __webpack_public_path__ + "img/BlendBuff-CriticalDamage.764189aa.png";